export default "<router-outlet></router-outlet>\n<app-loader></app-loader>\n";